import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Modal } from 'react-bootstrap';
import { requestForgotPassword } from '../services/auth';
import i18n from '../utils/i18n';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';

type FormValues = {
  email: string;
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Enter a valid email address').required('Required'),
});

const Forgot = () => {
  const [loading, setLoading] = useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const navigate = useNavigate();

  const onSubmit = async (values: FormValues) => {
    try {
      setLoading(true);
      await requestForgotPassword(values.email);
      setShowConfirmationModal(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    isValid,
    errors,
    touched,
    values,
  } = useFormik({
    initialValues: { email: '' },
    validationSchema,
    onSubmit,
    validateOnBlur: false,
    initialErrors: {
      email: 'Obrigatório',
    },
  });

  return (
    <>
      <div className="auth-container">
        <div className="container-fluid h-100">
          <div className="row h-100 align-items-center justify-content-center">
            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
              <div className="auth-card">
                <div className="auth-logo-container">
                  <img
                    src="assets/images/logo-only.png"
                    className="auth-logo"
                    alt="Silk Secret"
                  />
                  <h1 className="auth-brand-name">silk secret</h1>
                </div>

                <h2 className="auth-title">{i18n.t<string>('ForgotPassword.title')}</h2>

                <form onSubmit={handleSubmit} className="auth-form">
                  <div className="input-group">
                    <i className="ti-email input-icon"></i>
                    <input
                      type="text"
                      id="email"
                      className="form-input"
                      placeholder={i18n.t<string>('ForgotPassword.form.email')}
                      inputMode="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.email}
                      disabled={loading}
                    />
                    {touched.email && errors.email && (
                      <div className="input-error">
                        <i className="feather-alert-circle"></i>
                        {errors.email}
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={!isValid || loading}
                    className="btn-auth"
                  >
                    {loading ? (
                      <div className="auth-loading">
                        <div className="spinner"></div>
                        <span>Enviando</span>
                      </div>
                    ) : (
                      i18n.t<string>('ForgotPassword.button')
                    )}
                  </button>
                </form>

                <div className="signup-link">
                  <a href="/login">
                    {i18n.t<string>('ForgotPassword.backBtn')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
        >
          <Modal.Header
            closeButton
            onClick={() => setShowConfirmationModal(false)}
            className="bg-white"
            style={{
              border: 0,
              borderRadius: 0,
              padding: 20,
              borderTopLeftRadius: 10,
              WebkitBorderTopRightRadius: 10,
            }}
          />
          <Modal.Body
            className="bg-white"
            style={{
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
            }}
          >
            <p className="font-xs text-black">
              {`Se você possui uma conta cadastrada, as instruções para redefinir sua senha foram enviadas para o e-mail informado.`}{' '}
            </p>
            <div className="form-group mb-1">
              <Button
                onClick={() => {
                  setShowConfirmationModal(false);
                  navigate('/login');
                }}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Forgot;